import * as mws from '@/shared/MwsViewModels';
import { Prop } from 'vue-property-decorator';

export default class RowViewModel {
    rowItems: mws.ISupercard[];

    constructor(items: mws.ISupercard[]){
        this.rowItems = items;
    }
}